<template>
  <div>
    <entity-edit-form
      ref="form"
      :title="title"
      :data-service="dataService"
      :create-entity="isCreate"
      :fields="fields"
      :list-route-name="listRouteName"
      :item-id="$route.params.id"
      @entity-edited="afterEdit"
    >
      <template #top-action="{ item, loading }">
        <v-btn
          v-if="canConnectBranch(item)"
          color="success"
          large
          :disabled="connectionInProgress || loading"
          @click="showConnectDialog = true"
        >
          Подключить к FAKT
        </v-btn>
      </template>
      <template #field.jupiterSync="{ item, loading }">
        <v-checkbox
          v-model="item.jupiterSync"
          label="Синхронизация с юпитер включена"
          :disabled="loading || isJupiterLocked(item)"
          :hint="isJupiterLocked(item) ? 'Филиал подключён к FAKT — синхронизацию обратно не включить' : ''"
          persistent-hint
        />
      </template>
      <template #field.connectionDate="{item}">
        <read-only-text-field
          :class="item.connectionDate ? 'color-green' : 'color-red'"
          label="Статус подключения к FAKT"
          :value="getConnectionMessage(item.connectionDate)"
        />
      </template>
    </entity-edit-form>
    <primary-confirm-dialog
      v-model="showConnectDialog"
      title="Подключить филиал к FAKT.CRM?"
      :loading="connectionInProgress"
      close-after-loading
      @confirm="connectBranch"
    >
      <template #subtitle>
        <font-awesome-icon
          class="mr-1"
          icon="exclamation-triangle"
        />
        <span>Убедитесь что филиал и его оборудование полностью настроены, проверены и готовы к работе!</span>
      </template>
    </primary-confirm-dialog>
  </div>
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm'
  import permissions from '@/mixins/permissions'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import FilialDataService from '@/services/api/FilialDataService'
  import filialsApi from '@/api/filials'
  import snackbarMessage from '@/mixins/snackbar-message'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import ReadOnlyTextField from '@/components/ui/crud/fields/ReadOnlyTextField.vue'

  export default {
    components: { EntityEditForm, PrimaryConfirmDialog, ReadOnlyTextField },
    mixins: [permissions, snackbarMessage],
    data () {
      return {
        title: 'Редактирование филиала',
        isCreate: false,
        listRouteName: 'filialsList',
        dataService: FilialDataService,
        fields: FilialDataService.getCrudFields(),
        connectionInProgress: false,
        showConnectDialog: false,
      }
    },
    methods: {
      afterEdit () {
        this.$store.dispatch('branches/fetchBranches')
      },
      isJupiterLocked (filial) {
        return Boolean(filial.connectionDate) && !filial.jupiterSync
      },
      canConnectBranch (filial) {
        return this.userCan(CRMPermission.ConnectFilial) && !filial.connectionDate
      },
      getConnectionMessage (connectionDate) {
        if (!connectionDate) {
          return 'Не подключен'
        }

        const date = new Date(Date.parse(connectionDate)).toLocaleDateString(this.$i18n.locale, {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })

        return `Подключен ${date}`
      },
      async connectBranch () {
        this.connectionInProgress = true
        try {
          await filialsApi.connect(this.$route.params.id)
          this.$refs.form.fetchEditedItemData()
          this.afterEdit()
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.connectionInProgress = false
        }
      },
    },
  }
</script>
